<ng-container *ngIf="!isLoading && currentView; else loadingTpl">
  <app-header></app-header>
  <main class="main-content">
    <ng-container [ngSwitch]="currentView">
      <app-login *ngSwitchCase="'login'"></app-login>
      <app-home *ngSwitchCase="'home'"></app-home>
      <app-basic-data *ngSwitchCase="'basic-data'"></app-basic-data>
      <app-application-form *ngSwitchCase="'application-form'"></app-application-form>
    </ng-container>
  </main>
  <app-footer></app-footer>
</ng-container>
<ng-template #loadingTpl>
  <div class="loading-screen">
    <app-charging></app-charging>
  </div>
</ng-template>